export default "__VITE_ASSET__DVruYVKO__"